module.exports = __webpack_public_path__ + "media/images/copy-4caf6292001c9c6ba2945de5ca8f6c85.svg";